export default __webpack_public_path__ + "static/carlos@2x-d3ea937bb81ca28bacb244a04a54aa2d.jpg";